// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-range-picker-container {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;
}

.dashboard-date-picker {
  width: 200px !important;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #dde5ef;
  background: #ffffff;
  font-size: 14px;
  padding: 0 16px;
}

.dashboard-date-picker input {
  font-size: 14px;
}

.dashboard-date-picker .ant-picker-input > input::placeholder {
  color: #64748b;
}

.dashboard-date-dropdown .ant-picker-panel-container {
  width: 290px !important;
  min-width: 240px !important;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  height: 320px;
}

.dashboard-date-dropdown .ant-picker-content {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/DateRangePicker/DateRangePicker.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;AACF;;AAEA;EACE,eAAA;AACF","sourcesContent":[".date-range-picker-container {\r\n  display: flex;\r\n  gap: 16px; // smaller gap\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n}\r\n\r\n.dashboard-date-picker {\r\n  width: 200px !important;\r\n  height: 44px;\r\n  border-radius: 8px;\r\n  border: 1px solid #dde5ef;\r\n  background: #ffffff;\r\n  font-size: 14px;\r\n  padding: 0 16px;\r\n}\r\n\r\n.dashboard-date-picker input {\r\n  font-size: 14px;\r\n}\r\n\r\n.dashboard-date-picker .ant-picker-input > input::placeholder {\r\n  color: #64748b;\r\n}\r\n\r\n.dashboard-date-dropdown .ant-picker-panel-container {\r\n  width: 290px !important;\r\n  min-width: 240px !important;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 16px rgba(0,0,0,0.08);\r\n  height: 320px;\r\n}\r\n\r\n.dashboard-date-dropdown .ant-picker-content {\r\n  font-size: 12px; // smaller cells\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
